import { motion } from "framer-motion";
import { ArrowUpRight, Lock, Compass, BrainCircuit } from "lucide-react";
import { IMAGES } from "@/lib/constants";

const cards = [
  {
    icon: Lock,
    img: IMAGES.escapeRoom,
    title: "Edukacyjne Escape Roomy",
    desc: "Szyfry, kody i zagadki przyrodnicze, które zamieniają salę lekcyjną w pełną napięcia przygodę.",
    tag: "Szyfry & zagadki",
  },
  {
    icon: Compass,
    img: IMAGES.geography,
    title: "Geografia i Przyroda z Klasą",
    desc: "Innowacyjne pomysły na lekcje — od map i ekosystemów po terenowe wyzwania badawcze.",
    tag: "Pomysły na lekcje",
  },
  {
    icon: BrainCircuit,
    img: IMAGES.ai,
    title: "AI w Pracy Nauczyciela",
    desc: "Przewodniki, gotowe prompty i narzędzia, które oszczędzają godziny przygotowań.",
    tag: "Przewodniki & prompty",
  },
];

export default function Categories() {
  return (
    <section id="kategorie" className="py-20 md:py-32">
      <div className="w-full max-w-7xl mx-auto px-6 md:px-12">
        <div className="max-w-2xl">
          <span className="text-sm font-outfit uppercase tracking-[0.2em] text-gold">Kategorie główne</span>
          <h2 className="mt-4 font-outfit font-medium text-2xl sm:text-3xl lg:text-4xl tracking-tight text-ink leading-tight" data-testid="categories-title">
            Trzy ścieżki, jeden cel — lekcje, których uczniowie nie zapomną
          </h2>
        </div>

        <div className="mt-14 grid md:grid-cols-3 gap-8">
          {cards.map((c, i) => (
            <motion.article
              key={c.title}
              initial={{ opacity: 0, y: 36 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true, amount: 0.2 }}
              transition={{ duration: 0.7, delay: i * 0.12, ease: [0.22, 1, 0.36, 1] }}
              className="group bg-surface border border-line rounded-2xl overflow-hidden hover:-translate-y-1.5 hover:border-gold/60 shadow-clay hover:shadow-clay-lg transition-all duration-500"
              data-testid={`category-card-${i}`}
            >
              <div className="relative h-52 overflow-hidden">
                <img src={c.img} alt={c.title} className="w-full h-full object-cover transition-transform duration-700 group-hover:scale-105" />
                <span className="absolute top-4 left-4 inline-flex items-center gap-1.5 bg-beige/90 backdrop-blur-sm text-forest text-xs font-outfit px-3 py-1.5 rounded-2xl">
                  <c.icon className="h-3.5 w-3.5" strokeWidth={1.75} /> {c.tag}
                </span>
              </div>
              <div className="p-7">
                <h3 className="font-outfit font-medium text-xl text-ink flex items-start justify-between gap-3">
                  {c.title}
                  <ArrowUpRight className="h-5 w-5 text-gold shrink-0 transition-transform duration-300 group-hover:translate-x-0.5 group-hover:-translate-y-0.5" strokeWidth={1.75} />
                </h3>
                <p className="mt-3 font-manrope text-sm md:text-base text-ink-soft leading-relaxed">{c.desc}</p>
              </div>
            </motion.article>
          ))}
        </div>
      </div>
    </section>
  );
}
